/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_Q6Inputs */

const en_fw_faq_q6 = /** @type {(inputs: Fw_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the official Firefly Wedding website?`)
};

const zh_fw_faq_q6 = /** @type {(inputs: Fw_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是萤火之嫁官方网站吗？`)
};

/**
* | output |
* | --- |
* | "Is this the official Firefly Wedding website?" |
*
* @param {Fw_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_q6 = /** @type {((inputs?: Fw_Faq_Q6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_Q6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_q6(inputs)
	return zh_fw_faq_q6(inputs)
});
export { fw_faq_q6 as "fw.faq.q6" }